import { ENUM } from "~/plugins/constants/enum";
import { displayDate, getChatbotStatus } from "~/plugins/functions/display";

// For DTO Knowledge Document
export interface IModelGETKnowledgeDocumentRequest {
  orderBy?: string;
  orderType?: string;
  count?: boolean;
  page?: number;
  limit?: number;
  query?: string;
  knowledgeId?: string;
  status?: string;
}

export interface IModelGETKnowledgeDocumentResponse {
  id: string;
  knowledgeId: string;
  status: string;
  fileName: string;
  filePath: string;
  fileSize?: number;
  mimeType?: string;
  sourceGuide?: string;
  keyTopics?: object;
  markdownContentPath?: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt?: string | Date;
}

export class ModelGETKnowledgeDocument {
  id: string;
  knowledgeId: string;
  status: string;
  fileName: string;
  filePath: string;
  fileSize?: number;
  mimeType?: string;
  sourceGuide?: string;
  keyTopics?: object;
  markdownContentPath?: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt?: string | Date;

  displayCreatedAt: string;
  displayUpdatedAt: string;
  displayStatus: string;
  displayFileSize: string;

  constructor(props = {} as IModelGETKnowledgeDocumentResponse) {
    props = props ?? {} as IModelGETKnowledgeDocumentResponse;
    this.id = props.id || '';
    this.knowledgeId = props.knowledgeId || '';
    this.status = props.status || '';
    this.fileName = props.fileName || '';
    this.filePath = props.filePath || '';
    this.fileSize = props.fileSize || 0;
    this.mimeType = props.mimeType || '';
    this.sourceGuide = props.sourceGuide || '';
    this.keyTopics = props.keyTopics || {};
    this.markdownContentPath = props.markdownContentPath || '';
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    this.deletedAt = props.deletedAt;

    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true
    });
    this.displayStatus = getChatbotStatus(this.status);
    
    // Format file size
    if (this.fileSize) {
      const bytes = this.fileSize;
      if (bytes >= 1024 * 1024 * 1024) {
        this.displayFileSize = `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
      } else if (bytes >= 1024 * 1024) {
        this.displayFileSize = `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
      } else if (bytes >= 1024) {
        this.displayFileSize = `${(bytes / 1024).toFixed(1)} KB`;
      } else {
        this.displayFileSize = `${bytes} B`;
      }
    } else {
      this.displayFileSize = '0 B';
    }
  }
}

